import React from 'react';
import { useIntl } from 'ha/i18n';
import { H2 } from 'ha/ui.legacy/Headers';
import { Link } from 'ha/ui.legacy/Link';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

export interface CTAProps {
  url?: string;
  description?: string;
  linkText?: string;
}

const CommunityCTACard: React.FC<CTAProps> = ({
  url,
  description,
  linkText,
}) => {
  const { T, urlResolver } = useIntl();
  return (
    <div className="community-card back-purple-dark flexbox flex-direction__column flex-justify-end p-x-2">
      <H2 className="color-white">
        {description ||
          T(
            'Afraid to become homeless during your internship? Find a room in your new city',
          )}
      </H2>
      <Track name="Clicked CTA in a community page" type="link">
        <Link
          to={url || urlResolver.getBaseUrl()}
          skipLangFormat
          className="btn btn-white-purple btn-block text-bold btn-lg m-y-2 box-shadow-lg"
        >
          {linkText || T('Start searching')}
        </Link>
      </Track>
    </div>
  );
};

export { CommunityCTACard };
